<template>
  <div
    class="swiper-slide"
    style="width: 302px !important; padding: 0 8px;">
    <div class="payment-unit">
      <a class="payment-link">
        <div class="payment-card" :class="card.style">
          <span class="icon"></span>
          <span class="txt">{{ card.cardName }}</span>
          <span class="name">{{ ownerName }}</span>
          <span class="name"></span>
          <span
            class="account_number">
            {{ card.cardNumber }}
          </span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "CardSlider",
  props: {
    card: {
      type: Object,
      required: true,
      default: () => {
        return {
          cardCompany: "현대카드",
          cardName: "현대백화점카드",
          cardNumber: "123456******3821",
          cardType: "신용",
          customerId: "63584316",
          id: "c_XQL8RMy5pye9r7nO",
          methodKey: "",
          registeredAt: "Thu Mar 24 13:07:01 KST 2022",
          status: "true"
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      selectedParty: "amwaypay/selectedParty",
      masterName: "amwaypay/currentMasterName",
      subName: "amwaypay/currentSubName",
    }),
    ownerName() {
      return this.selectedParty === 0 ? this.masterName : this.subName;
    },
  },
}
</script>

<style scoped>

</style>
